import { ReactElement, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import MultipleDeclarationField from 'views/declarations/common/MultipleDeclarationField';
import { getFormikProps } from 'views/declarations/utils/form-utils';
import FormInput from '../../../../../components/ui/composed/declarations/formInput/DeclarationInput';
import { ValidationSchema, validators } from '../validations/validations';

type Fields = 'id';

export const taricAdditionalCodesBlockValidation: {
    childValidators: {
        'commodity.classification.tra': ValidationSchema<Fields>;
    };
} = {
    childValidators: {
        'commodity.classification.tra': {
            childValidators: {
                id: [validators.exact(4)],
            },
            stopAtNull: true,
        },
    },
};

export const taricAdditionalCodesFieldsValidation =
    taricAdditionalCodesBlockValidation.childValidators['commodity.classification.tra'];

interface Props extends BlockProps<Fields> {}

const TaricAdditionalCodesBlock = ({ path = 'commodity.classification', fieldOptions }: Props): ReactElement => {
    const { t } = useTranslation('form');

    const ucc = useMemo(() => '6/16', []);
    return (
        <MultipleDeclarationField pathPrefix={path} parent="tra" name="id">
            {({ form, field }, controls) => (
                <FormInput
                    required={fieldOptions?.id?.required ?? false}
                    refNumber={ucc}
                    label={t('taricAdditionalCodeIdentifier')}
                    {...getFormikProps(field.name, form)}
                    condensed
                    multipleF={controls}
                />
            )}
        </MultipleDeclarationField>
    );
};

export default TaricAdditionalCodesBlock;
